import { Image } from "@/components/displays";

export interface Question {
  id: string | number;
  title: string;
  body: React.ReactNode;
  caution?: string;
}

type PerfectNutritionQuestionBodyProps = {
  graphqlName: string;
  imageUrl: string;
};

const perfectNutritionQuestionBody = ({
  graphqlName,
  imageUrl,
}: PerfectNutritionQuestionBodyProps) => (
  <>
    1日に必要な栄養素の1/3がすべてとれる食品です※。
    <br />
    一般的に、公的機関が策定した食事摂取基準に基づき、1食に必要な栄養素がすべて必要量以上含まれる食品が、完全栄養食と呼ばれています。
    <br />
    含まれる栄養素は、下記の通りです。
    <Image
      src={imageUrl}
      alt={graphqlName}
      className="mg__bottom__s mg__top__s"
      width={334}
      height={225}
    />
  </>
);

export const questions = [
  {
    id: "perfect-nutrition-food-for-chocolate",
    title: "「完全栄養食（完全食）」とは、どのような食品ですか？",
    body: perfectNutritionQuestionBody({
      graphqlName: "BASE BREAD チョコレートの栄養素グラフ",
      imageUrl: "https://asset.basefood.co.jp/images/graph/graph_bb_chocolate_v1_12_h_notes.png",
    }),
    caution:
      "1食分（2袋）で、栄養素等表示基準値に基づき、脂質・飽和脂肪酸・炭水化物・ナトリウム以外のすべての栄養素で1日分の基準値の1/3以上を含む。",
  },
  {
    id: "perfect-nutrition-food-for-creamymushroom",
    title: "「完全栄養食（完全食）」とは、どのような食品ですか？",
    body: perfectNutritionQuestionBody({
      graphqlName: "BASE PASTA きのこクリームの栄養素グラフ",
      imageUrl: "https://asset.basefood.co.jp/images/graph/graph_bp_mushroom_v1_0_h_notes.png",
    }),
    caution:
      "1食分で、栄養素等表示基準値に基づき、脂質・飽和脂肪酸・炭水化物・ナトリウム以外のすべての栄養素で1日分の基準値の1/3以上を含む。",
  },
  {
    id: "perfect-nutrition-food-for-pancakemix",
    title: "「完全栄養食（完全食）」とは、どのような食品ですか？",
    body: perfectNutritionQuestionBody({
      graphqlName: "BASE Pancake Mixのグラフ",
      imageUrl: "https://asset.basefood.co.jp/images/graph/graph_bpm_pacakemix_v1_0_h_notes_2.png",
    }),
    caution:
      "1食分（BASE Pancake Mix1袋と卵Mサイズ1つ、牛乳(成分無調整)100mlを使用して調理した場合）で、栄養素等表示基準値に基づき、脂質・飽和脂肪酸・炭水化物・ナトリウム以外のすべての栄養素で1日分の基準値の1/3以上を含む。",
  },
  {
    id: "perfect-nutrition-food-for-cookies",
    title: "完全栄養食って、どんな食べもの？",
    body: "1日に必要な栄養素の1/3をすべてとれる食品です※。BASE Cookiesは、4袋で1食分の栄養素が含まれています。",
    caution:
      "1食（4袋）で、栄養素等表示基準値に基づき、脂質・飽和脂肪酸・炭水化物・ナトリウム以外のすべての栄養素で1日分の基準値の1/3以上を含む",
  },
  {
    id: "perfect-nutrition-food-for-subscription",
    title: "完全栄養食って、どんな食べもの？",
    body: "1日に必要な栄養素の1/3をすべてとれる食品です※。いそがしくて自炊ができないときでも、かんたんにおいしく栄養がとれます。",
    caution:
      "1食分（BASE BREADは2袋、BASE Cookiesは4袋、BASE YAKISOBAは2個、BASE FOOD Deliは1袋、BASE Pancake Mixは1袋と卵Mサイズ1つ、牛乳(成分無調整)100mlを使用して調理した場合）で、栄養素等表示基準値に基づき、脂質・飽和脂肪酸・炭水化物・ナトリウム以外のすべての栄養素で1日分の基準値の1/3以上を含む。",
  },
  {
    id: "must-eat-three-daily",
    title: "毎日3食食べなければいけない？",
    body: "毎食でも食べていただけますが、1日3食食べなくても大丈夫です。\n目安として月20食、小学校の給食と同じ頻度をおすすめしています。バランスのよい食事を1日に1食とることで、栄養のベースづくりをサポートします。",
  },
  {
    id: "how-to-eat-for-bread",
    title: "どうやって食べればいい？",
    body: "袋からとり出してそのまま食べられます。バターやチョコをぬったり、ハムやチーズを挟んだり、お好きなアレンジでおたのしみください。\n惣菜パンのBASE BREAD カレーは、温めて食べるのがおすすめです。温めることでふんわりとした食感になり、おいしくお召しあがりいただけます。",
  },
  {
    id: "how-to-eat-for-pasta",
    title: "調理方法は？",
    body: "熱湯でゆでて、お好きなソースと一緒にお召しあがりください。パスタ、焼きそば、カレーまで、色々なアレンジをたのしめます。",
  },
  {
    id: "how-to-eat-for-subscription",
    title: "どうやって食べればいい？",
    body: "パンはそのままもしくは電子レンジやトースターで温めて、クッキーはそのままお召しあがりください。",
  },
  {
    id: "when-to-eat",
    title: "いつ食べればいい？",
    body: "気分転換したいとき、小腹がすいたときのおやつにおすすめです。",
  },
  {
    id: "what-ingredients-for-bread",
    title: "原材料には何が入っている？",
    body: (
      <>
        <Image
          src="https://asset.basefood.co.jp/images/parts/thumb_bb_ingredients.jpg"
          alt="BASE BREADの原材料のサムネイル"
          className="mg__bottom__s"
          width={334}
          height={188}
        />
        <br />
        <p>小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上ブレンドしてつくっています。</p>
      </>
    ),
  },
  {
    id: "what-ingredients-for-cocoa",
    title: "原材料には何が入っている？",
    body: "全粒粉やアーモンド、米ぬかをブレンドした生地に、ココアを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-coconut",
    title: "原材料には何が入っている？",
    body: "全粒粉やアーモンド、米ぬかをブレンドした生地に、ココナッツを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-earlgrey",
    title: "原材料には何が入っている？",
    body: "全粒粉やアーモンド、米ぬかをブレンドした生地に、アールグレイを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-matcha",
    title: "原材料には何が入っている？",
    body: "全粒粉やアーモンド、米ぬかをブレンドした生地に、抹茶を混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-sweetpotato",
    title: "原材料には何が入っている？",
    body: "全粒粉やアーモンド、米ぬかをブレンドした生地に、さつまいもを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-cheese",
    title: "原材料には何が入っている？",
    body: "全粒粉や米ぬかをブレンドした生地に、チェダーチーズを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-pepper",
    title: "原材料には何が入っている？",
    body: "全粒粉や米ぬかをブレンドした生地に、ブラックペッパーを混ぜ込んでいます。",
  },
  {
    id: "what-ingredients-for-pasta",
    title: "原材料には何が入っている？",
    body: "小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上ブレンドしてつくっています。",
  },
  {
    id: "what-ingredients-for-deli-pasta",
    title: "原材料には何が入っている？",
    body: "小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上つかっています。",
  },
  {
    id: "what-ingredients-for-yakisoba",
    title: "原材料には何が入っている？",
    body: "小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上ブレンドしてつくっています。",
  },
  {
    id: "what-ingredients-for-subscription",
    title: "原材料には何が入っている？",
    body: "小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上ブレンドしてつくっています。",
  },
  {
    id: "eat-all-at-once",
    title: "1食分を一度に食べなければいけない？",
    body: "4袋で1食分の栄養素ですが、必ず一度に4袋食べる必要はありません。1袋ずつでも、栄養のベースをととのえることができます。",
  },
  {
    id: "expiration-date-for-bread",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/360029507251" target="_blank">
          こちら
        </a>
        をご覧ください。
        <br />
        常温で保存できるロングライフパンなので、備蓄にもおすすめ。水分や酸素のコントロールをおこなうことで、常温での長期保存を実現しています。
      </>
    ),
  },
  {
    id: "expiration-date-for-cookies",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/6638687745561" target="_blank">
          こちら
        </a>
        をご覧ください。
        <br />
        常温で保存いただけます。
      </>
    ),
  },
  {
    id: "expiration-date-for-deli-pasta",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/15028026031257" target="_blank">
          こちら
        </a>
        をご覧ください。
      </>
    ),
  },
  {
    id: "expiration-date-for-pasta",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/360029458991" target="_blank">
          こちら
        </a>
        をご覧ください。
        <br />
        パッケージ内の酸素を抜いた上で加熱殺菌を行うことにより、生麺でも長期保存ができるよう工夫しました。
      </>
    ),
  },
  {
    id: "expiration-date-for-subscription",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/360029507251" target="_blank">
          こちら
        </a>
        をご覧ください。
        <br />
        <br />
        常温で保存可能です。
      </>
    ),
  },
  {
    id: "expiration-date-for-deli-subscription",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a href="https://basefood.zendesk.com/hc/ja/articles/15028026031257" target="_blank">
          こちら
        </a>
        をご覧ください。
      </>
    ),
  },
  {
    id: "how-to-cook-for-bolognese",
    title: "調理方法は？",
    body: (
      <>
        調理方法
        <br />
        1. おもての切り込み線に沿って、外袋に切り込みを入れてください。 <br />
        2.
        凍ったままの商品を、写真がある面を上にして、外袋のまま電子レンジであたためてください。目安は、
        500W 7分00秒、600W 5分30秒です。
        <br />
        3. 外袋からトレーをとりだし、よく混ぜてお召しあがりください。
        <br />
        <br />
        注意事項
        <br />
        ・オート(自動)機能は使わないでください。
        <br />
        ・お使いの機種に応じて、調理時間はご調整ください。冷たい場合は一度かき混ぜてから10秒ずつ再加熱してください。
        <br />
        ・加熱条件によりスパゲッティ・ソース・具材の一部が焦げることがあります。
      </>
    ),
  },
  {
    id: "how-to-cook-for-tarako",
    title: "調理方法は？",
    body: (
      <>
        調理方法
        <br />
        1. おもての切り込み線に沿って、外袋に切り込みを入れてください。 <br />
        2.
        凍ったままの商品を、写真がある面を上にして、外袋のまま電子レンジであたためてください。目安は、
        500W 4分40秒、600W 3分50秒です。
        <br />
        3. 外袋からトレーをとりだし、よく混ぜてお召しあがりください。
        <br />
        <br />
        注意事項
        <br />
        ・オート(自動)機能は使わないでください。
        <br />
        ・お使いの機種に応じて、調理時間はご調整ください。冷たい場合は一度かき混ぜてから10秒ずつ再加熱してください。
        <br />
        ・加熱条件によりスパゲッティ・ソース・具材の一部が焦げることがあります。
      </>
    ),
  },
  {
    id: "how-to-cook-for-creamymushroom",
    title: "調理方法は？",
    body: (
      <>
        調理方法
        <br />
        1. おもての切り込み線に沿って、外袋に切り込みを入れてください。 <br />
        2.
        凍ったままの商品を、写真がある面を上にして、外袋のまま電子レンジであたためてください。目安は、
        500W 6分30秒、600W 5分30秒です。
        <br />
        3. 外袋からトレーをとりだし、よく混ぜてお召しあがりください。
        <br />
        <br />
        注意事項
        <br />
        ・オート(自動)機能は使わないでください。
        <br />
        ・お使いの機種に応じて、調理時間はご調整ください。冷たい場合は一度かき混ぜてから10秒ずつ再加熱してください。
        <br />
        ・加熱条件によりスパゲッティ・ソース・具材の一部が焦げることがあります。
      </>
    ),
  },
  {
    id: "how-to-cook-for-deli-pasta",
    title: "調理方法は？",
    body: (
      <>
        調理方法
        <br />
        1. おもての切り込み線に沿って、外袋に切り込みを入れてください。 <br />
        2.
        凍ったままの商品を、写真がある面を上にして、外袋のまま電子レンジであたためてください。目安は以下のとおりです。
        <br />
        ・ボロネーゼ：500W 7分00秒、600W 5分30秒
        <br />
        ・たらこ：500W 4分40秒、600W 3分50秒
        <br />
        ・きのこクリーム：500W 6分30秒、600W 5分30秒
        <br />
        3. 外袋からトレーをとりだし、よく混ぜてお召しあがりください。
        <br />
        <br />
        注意事項
        <br />
        ・オート(自動)機能は使わないでください。
        <br />
        ・お使いの機種に応じて、調理時間はご調整ください。冷たい場合は一度かき混ぜてから10秒ずつ再加熱してください。
        <br />
        ・加熱条件によりスパゲッティ・ソース・具材の一部が焦げることがあります。
      </>
    ),
  },
  {
    id: "how-many-in-fridge-for-deli-pasta",
    title: "冷蔵庫には何個はいる？",
    body: (
      <>
        1人暮らし用の小さな冷蔵庫（100~150L）をお持ちの方は、6食前後のご購入がおすすめです。
        <br /> ※1人暮らし用の冷蔵庫の一般的な冷凍スペースに、最大12食程度入ります。
        <br />
        <br />
        2~3人用の冷蔵庫（200~300L）をお持ちの方は、10食前後のご購入がおすすめです。
        <br />
        ※2~3人用の冷蔵庫の一般的な冷凍スペースに、最大20食程度入ります。
      </>
    ),
  },
  {
    id: "what-ingredients-for-pancake-mix",
    title: "原材料には何が入っている？",
    body: (
      <>
        <Image
          src="https://asset.basefood.co.jp/images/parts/thumb_bb_ingredients.jpg"
          alt="BASE PANCAKE MIXの原材料のサムネイル"
          className="mg__bottom__s"
          width={334}
          height={188}
        />
        <br />
        小麦全粒粉や大豆、昆布など、栄養豊富な食材を10種類以上ブレンドしてつくっています。
      </>
    ),
  },
  {
    id: "expiration-date-for-pancake-mix",
    title: "賞味期限はどのくらい？",
    body: (
      <>
        賞味期限は
        <a
          href="https://basefood.zendesk.com/hc/ja/articles/31416629265689"
          target="_blank"
          rel="noopener noreferrer"
        >
          こちら
        </a>
        をご覧ください。
      </>
    ),
  },
] as const satisfies Question[];

export type QuestionId = (typeof questions)[number]["id"];
